export const validateFlscopySchema = json => {
    return true;
};
